import { render } from "./OrdersAdmin.vue?vue&type=template&id=600c76b3"
import script from "./OrdersAdmin.vue?vue&type=script&lang=js"
export * from "./OrdersAdmin.vue?vue&type=script&lang=js"

import "./OrdersAdmin.vue?vue&type=style&index=0&id=600c76b3&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__